"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var PropTypes = _interopRequireWildcard(require("prop-types"));
var _ReplaceSlides = require("./ReplaceSlides.styled");
var _utils = require("../../utils");
var _constants = require("../../constants");
var _FooterWithButtons = require("../FooterWithButtons");
var _Alert = require("../Alert");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ReplaceSlides = function ReplaceSlides(_ref) {
  var _onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel,
    oldSource = _ref.oldSource;
  var inputFile = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    uploadError = _useState2[0],
    setUploadError = _useState2[1];
  var _useState3 = (0, _react.useState)(oldSource),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    source = _useState4[0],
    setSource = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    hasNewSource = _useState6[0],
    setHasNewSource = _useState6[1];
  var handleButtonClick = function handleButtonClick() {
    return inputFile.current.click();
  };
  var onFileChange = function onFileChange(file) {
    var error = '';
    if (+file.size > _constants.SOURCE_MAX_FILE_SIZE) {
      error = "File exceeds size limitation of (".concat((0, _utils.formatBytes)(_constants.SOURCE_MAX_FILE_SIZE), ")");
      setUploadError(error);
    }
    if (error !== '') {
      return;
    }
    var source = {
      ext: (0, _utils.getFileExtension)(file.name),
      title: file.name,
      value: file
    };
    setHasNewSource(true);
    setSource(source);
  };
  var isDisabled = uploadError !== '' || !hasNewSource;
  return /*#__PURE__*/_react["default"].createElement(_ReplaceSlides.ReplaceSlidesContainer, null, /*#__PURE__*/_react["default"].createElement("h4", null, "Replace Slides"), /*#__PURE__*/_react["default"].createElement(_ReplaceSlides.InstructionText, {
    className: "pt-2"
  }, "We recommend having a horizontal 16:9 aspect ratio and use maximum 1920*1080 px."), /*#__PURE__*/_react["default"].createElement(_ReplaceSlides.FileWrapper, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/_react["default"].createElement(_ReplaceSlides.HiddenInputFile, {
    "data-testid": "replaceSlideInput",
    type: "file",
    "aria-labelledby": "replaceSlideLabel",
    name: "file",
    onChange: function onChange(e) {
      return onFileChange(e.target.files[0]);
    },
    id: "sourceFile",
    accept: ".pdf",
    ref: inputFile
  }), /*#__PURE__*/_react["default"].createElement(_ReplaceSlides.StyledButton, {
    onClick: handleButtonClick,
    "data-testid": "fileInputButton",
    color: "light"
  }, "Choose file"), /*#__PURE__*/_react["default"].createElement(_ReplaceSlides.SlideTitle, {
    "data-testid": "sourceTitle"
  }, source === null || source === void 0 ? void 0 : source.title)), uploadError !== '' && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "uploadError"
  }, /*#__PURE__*/_react["default"].createElement(_Alert.Alert, {
    type: "failure",
    title: uploadError,
    size: "small"
  }))), /*#__PURE__*/_react["default"].createElement(_ReplaceSlides.HelpText, null, "PDF (2GB file size limit). We recommend having a horizontal 16:9 aspect ratio and use maximum 1920*1080 px."), /*#__PURE__*/_react["default"].createElement(_ReplaceSlides.FooterWrapper, null, /*#__PURE__*/_react["default"].createElement(_FooterWithButtons.FooterWithButtons, {
    createButtonText: "Replace",
    onCancel: onCancel,
    onSubmit: function onSubmit() {
      return _onSubmit(source);
    },
    disabled: isDisabled
  })));
};
ReplaceSlides.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  oldSource: PropTypes.object.isRequired
};
var _default = exports["default"] = ReplaceSlides;